// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__31T-2","viewAllResultsContainer":"styles_viewAllResultsContainer__wzLi8","sectionContainer":"styles_sectionContainer__3m87y"};